import { ChatConversation, GroupChat } from '../types/chats';
import { getUserClubs, getClubById, getChatMessages, CURRENT_USER_ID as CLUBS_CURRENT_USER_ID } from './mockClubsData';

// Use the same current user from clubs data
export const CURRENT_USER_ID = CLUBS_CURRENT_USER_ID;

// Mock personal chat conversations
const mockChatConversations: ChatConversation[] = [
  {
    id: 'chat-1',
    userId: 'user-2',
    userName: 'Rajesh Kumar',
    lastMessage: 'Great! Let\'s schedule a meeting next week.',
    lastMessageTime: new Date(Date.now() - 30 * 60 * 1000), // 30 minutes ago
    unreadCount: 2,
    isOnline: true,
  },
  {
    id: 'chat-2',
    userId: 'user-3',
    userName: 'Priya Sharma',
    lastMessage: 'Thanks for the introduction! I\'ll reach out to them.',
    lastMessageTime: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    unreadCount: 0,
    isOnline: false,
  },
  {
    id: 'chat-3',
    userId: 'user-4',
    userName: 'Amit Patel',
    lastMessage: 'Can you send me the project details?',
    lastMessageTime: new Date(Date.now() - 5 * 60 * 60 * 1000), // 5 hours ago
    unreadCount: 1,
    isOnline: true,
  },
  {
    id: 'chat-4',
    userId: 'user-5',
    userName: 'Sneha Reddy',
    lastMessage: 'I reviewed the proposal. Looks good!',
    lastMessageTime: new Date(Date.now() - 24 * 60 * 60 * 1000), // 1 day ago
    unreadCount: 0,
    isOnline: false,
  },
  {
    id: 'chat-5',
    userId: 'user-6',
    userName: 'Vikram Singh',
    lastMessage: 'Are you attending the event tomorrow?',
    lastMessageTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    unreadCount: 0,
    isOnline: true,
  },
  {
    id: 'chat-6',
    userId: 'user-7',
    userName: 'Anita Desai',
    lastMessage: 'Perfect! I\'ll see you there.',
    lastMessageTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), // 3 days ago
    unreadCount: 5,
    isOnline: false,
  },
];

// Helper functions
export const getPersonalChats = (): ChatConversation[] => {
  // Return chats sorted by most recent first
  return [...mockChatConversations].sort((a, b) => 
    b.lastMessageTime.getTime() - a.lastMessageTime.getTime()
  );
};

export const getGroupChats = (): GroupChat[] => {
  // Get clubs the current user is a member of
  const userClubs = getUserClubs(CURRENT_USER_ID);
  
  // Create group chats from clubs with chat enabled
  const groupChats: GroupChat[] = userClubs
    .filter(club => club.chatEnabled)
    .map(club => {
      const chatMessages = getChatMessages(club.id);
      const lastMessage = chatMessages.length > 0 
        ? chatMessages[chatMessages.length - 1]
        : null;
      
      return {
        id: `group-${club.id}`,
        clubId: club.id,
        clubName: club.name,
        lastMessage: lastMessage?.message || 'No messages yet',
        lastMessageTime: lastMessage?.createdAt || club.createdAt,
        unreadCount: 0, // Could be calculated based on user's last read time
        memberCount: club.memberCount,
      };
    });
  
  // Sort by most recent first
  return groupChats.sort((a, b) => 
    b.lastMessageTime.getTime() - a.lastMessageTime.getTime()
  );
};

// Format relative time (same logic as mockWorkData)
export const getRelativeTime = (date: Date): string => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return 'Just now';
  }
  
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
};
